var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"business-container"},[_c('div',[_c('div',{staticClass:"chart",attrs:{"id":"chart_left2"}}),_c('span',{staticClass:"text"},[_vm._v("已开设直播课的专业覆盖率")]),_c('div',{staticClass:"right-chart",attrs:{"id":"chart_left3"}}),_c('span',{staticClass:"right-text"},[_vm._v("已开设自建课的专业覆盖率")])])])
}]

export { render, staticRenderFns }